import { ReactNode, HTMLAttributes } from 'react';
import { Stack } from '../Stack';
import { ActionElementsContainer, AppbarContainer } from './style';

export interface AppbarProps extends HTMLAttributes<HTMLDivElement> {
    leftSide?: ReactNode;
    rightSide?: ReactNode;
    rightActions?: ReactNode;
    small?: boolean;
    hasBorder?: boolean;
}

const Appbar = ({ leftSide, rightSide, rightActions, ...other }: AppbarProps) => (
    <AppbarContainer hasRightActions={!!rightActions} role="banner" {...other}>
        <Stack distribution="space-between" itemAlignment="center">
            {leftSide || <div />}
            <Stack spacing={rightActions ? '200' : '0'} itemAlignment="center">
                {rightSide}
                {rightActions ? <ActionElementsContainer>{rightActions}</ActionElementsContainer> : null}
            </Stack>
        </Stack>
    </AppbarContainer>
);

export default Appbar;
